import axios from 'axios';
import Vue from 'vue';

// axios.defaults.baseURL = config.api_base_url;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
// axios.defaults.headers.post['Access-Control-Allow-Methods'] = 'PUT,POST,GET,DELETE,OPTIONS';
// axios.defaults.headers.post['Access-Control-Allow-Headers'] = 'Content-Type,Content-Length, Authorization, Accept,X-Requested-With';

axios.interceptors.request.use(config => {
    // 请求记录，用于跳转页面时取消请求
    config.cancelToken = new axios.CancelToken(cancel => {
        if (!window.__axiosPromiseArr) {
            window.__axiosPromiseArr = [];
        }
        window.__axiosPromiseArr.push({cancel})
    });
    Vue.$indicator.open('加载中...');
    return config;
},error => {
    return Promise.reject(error);
});

// 响应拦截器
axios.interceptors.response.use(response => {
    Vue.$indicator.close();
    if (response.status >= 300) {
        return Promise.reject({
            response
        });
    }
    if (response.data.error) {
        Vue.$toast(response.data.error);
        return Promise.reject({
            response
        });
    }
    return response;
}, error => {
    // Do something with response error
    Vue.$indicator.close();
    Vue.$toast('加载失败，请重新尝试！');
    return Promise.reject(error);
});
export default Object.assign({}, axios);